import { Routes } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { isActiveGuard } from './auth/guards/is-active';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AutoLoginPartialRoutesGuard, isActiveGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./features/home/pages/home').then((m) => m.HomePage),
      },
      {
        path: 'users',
        loadChildren: () => import('./features/user/user.routes').then((m) => m.userRoutes),
      },
      {
        path: 'roles',
        loadChildren: () => import('./features/role/role.routes').then((m) => m.roleRoutes),
      },
      {
        path: 'logos',
        loadChildren: () => import('./features/logo/logo.routes').then((m) => m.logoRoutes),
      },
      {
        path: 'backgrounds',
        loadChildren: () =>
          import('./features/background/background.routes').then((m) => m.backgroundRoutes),
      },
      {
        path: 'ticket-layouts',
        loadChildren: () =>
          import('./features/ticket-layout/ticket-layout.routes').then((m) => m.ticketLayoutRoutes),
      },
    ],
  },
  {
    path: 'forbidden',
    loadComponent: () => import('./core/error/pages/forbidden').then((m) => m.Forbidden),
  },
];
